import defaultAxios from 'axios';
import {
  TransProgressKind,
  arquivoUtils,
  transientRequest,
  useTransProgress
} from 'common/components';
import { getContentType } from 'common/utils';
import { axios } from 'libs';

import * as ArquivoService from './ArquivoService';

const resource = '/processosExterno';

const getUrlUpload = (processoId, fileName, contentType, fileId) => {
  return axios.get(
    `${resource}/cloud/url/upload${processoId}&fileName=${encodeURIComponent(
      fileName
    )}&contentType=${contentType}`,
    transientRequest({
      fileId
    })
  );
};

const getUrlsMultipartUpload = (
  processoId,
  fileName,
  contentType,
  quantidadeDePartes,
  config
) => {
  return axios.post(
    `${resource}/cloud/url/multipart${processoId}&fileName=${encodeURIComponent(
      fileName
    )}&contentType=${contentType}&quantidadeDePartes=${quantidadeDePartes}`,
    null,
    config
  );
};

const finalizarMultipartUpload = (
  processoId,
  fullPath,
  uploadId,
  partes,
  config
) => {
  return axios.post(
    `${resource}/cloud/url/multipart/finalizar${processoId}`,
    {
      fullPath,
      uploadId,
      partes
    },
    config
  );
};

const abortarMultipartUpload = (processoId, fullPath, fileName, uploadId) => {
  return axios.post(`${resource}/cloud/url/multipart/abortar${processoId}`, {
    fullPath,
    fileName,
    uploadId
  });
};

const uploadArquivoMultipart = (
  processoId,
  file,
  fileName,
  contentType,
  progress
) => {
  return arquivoUtils.uploadArquivoMultipart(
    {
      abortarMultipartUpload: (fullPath, nome, uploadId) =>
        abortarMultipartUpload(processoId, fullPath, nome, uploadId),
      enviarParteArquivoParaServidor:
        ArquivoService.enviarParteArquivoParaServidor,
      finalizarMultipartUpload: (fullPath, uploadId, partes, configs) =>
        finalizarMultipartUpload(
          processoId,
          fullPath,
          uploadId,
          partes,
          configs
        ),
      gerarUrlsParaMultipartUpload: (
        filePath,
        nome,
        tipoConteudo,
        qtdPartes,
        configs
      ) =>
        getUrlsMultipartUpload(
          processoId,
          nome,
          tipoConteudo,
          qtdPartes,
          configs
        )
    },
    0,
    file,
    fileName,
    progress,
    contentType
  );
};

const uploadArquivoSingle = async (
  processoId,
  file,
  fileName,
  contentType,
  progress
) => {
  const { data: arquivoUrl } = await getUrlUpload(
    processoId,
    fileName,
    contentType,
    progress.fileId
  );

  await defaultAxios.put(
    arquivoUrl.urlAssinada,
    file,
    transientRequest(
      {
        ...progress,
        headers: {
          'Content-Type': contentType
        }
      },
      true,
      false
    )
  );

  return arquivoUrl;
};

const uploadArquivoCloud = (
  processoId,
  file,
  fileName,
  contentType,
  progress
) => {
  return arquivoUtils.shouldUseMultipartUpload(file)
    ? uploadArquivoMultipart(processoId, file, fileName, contentType, progress)
    : uploadArquivoSingle(processoId, file, fileName, contentType, progress);
};

export const getTipoProcessoPadrao = () => {
  return axios.get(`${resource}/tipo-padrao`);
};

export const salvarArquivos = (processoId, files, isFileCloud) => {
  const promises = files
    .map(file => {
      const formData = new FormData();

      formData.append('files', file);

      if (file.documento) {
        formData.append('documento', file.documento.id);
      }

      return formData;
    })
    .map(data => {
      let path = '/arquivo';

      if (data.get('documento')) {
        path = `${path}/documento/${data.get('documento')}`;
      }

      const file = data.get('files');
      const fileName = file?.name || 'Arquivo';
      const configs = useTransProgress(fileName, TransProgressKind.UPLOAD);

      if (!isFileCloud) {
        return axios.post(`${resource}${path}/${processoId}`, data, configs);
      }

      const contentType = getContentType(fileName);

      return uploadArquivoCloud(
        processoId,
        file,
        fileName,
        contentType,
        configs
      ).then(arquivoUrl =>
        axios.post(
          `${resource}/cloud${path}${processoId}&fileName=${encodeURIComponent(
            fileName
          )}&contentType=${contentType}`,
          arquivoUrl,
          transientRequest(configs, false, true)
        )
      );
    });

  return Promise.all(promises);
};

export const save = (entidadeId, processo) => {
  return axios.post(
    entidadeId ? `${resource}/${entidadeId}` : resource,
    processo
  );
};

export const getConfig = entidade => {
  return axios.get(
    entidade ? `${resource}/${entidade}/config` : `${resource}/config`
  );
};
